<template>
  <div class="pchomebox">
    <full-page :options="options">
    <div class="section">
      <div class="box1">
        <div class="hand_phone"></div>
        <div class="banxin">
          <Header :istab='true'></Header>



          <img class="txtimg" src="https://resource.imbeiyu.com/nnxqGw/img/pic-slogan1.png" alt="">
            <ul class="lods">
              <li><a href="https://api.imbeiyu.com/call.do?cmd=download.getUrl&isIos=1"> iOS下载</a> </li>
              <li><a href="https://api.imbeiyu.com/call.do?cmd=download.getUrl">Android下载</a> </li>
              <!-- <li @mouseout="outqrcodeStyle()" @mouseover="qrcodeStyle()" class="code pr"> <span>扫码下载</span>
                <p v-if="qrcode" id="qrcode"></p>
              </li> -->
            </ul>
        </div>
          <div class="jimu-page1-down">
          <div class="jimu-page1-down-icon"></div>
          <div class="jimu-page1-down-text">向下滑动</div>
          </div>
        </div>
      </div>
      <!-- <div class="section">

        <div class="box2">
          <img class="box2bgim" src="https://resource.imbeiyu.com/nnxqGw/img/pc_about1.png" alt="">
          <div class="jimu-page1-down">
            <img src="https://resource.imbeiyu.com/nnxqGw/img/go_down.png" alt="">
          </div>
        </div>
      </div> -->
      <div class="section">
        <div class="box3">
          <div class="banxin">
            <h2>让生活更精彩 让社交更亲近</h2>
            <p class="txt"> 型男美女聚集地 总有一款合适你</p>
            <ul class="listimg">
              <li v-for="(item, index) in listimg" :key="index"
                :class="index == 0 || index == 2 || index == 5 || index == 7 ? 'li1' : 'li2'">
                <img :src="item.head" alt="">
                <div class="bgimg">

    </div>
                <div class="user_info">
                  <p> <span>{{ item.name }}</span> <span>{{ item.location }}</span> </p>
                  <p>{{ item.sex }} {{ item.age }}岁</p>
                  <p>{{ item.about }}</p>
                </div>
              </li>



            </ul>

          </div>
          <div class="jimu-page1-down">
            <img src="https://resource.imbeiyu.com/nnxqGw/img/go_down.png" alt="">
          </div>
        </div>
      </div>
      <div class="section">

        <div class="box4">

          <!-- <h2>直播我的美 暖暖星球你的心</h2>
                            <p class="txt">万般皆苦 有我皆甜</p> -->
          <!-- <div class="box2bgim"></div> -->
          <img class="abooutNuan" src="https://resource.imbeiyu.com/nnxqGw/img/aboout_nuan.png" alt="">
          <div class="jimu-page1-down">
            <img src="https://resource.imbeiyu.com/nnxqGw/img/go_down.png" alt="">
          </div>
        </div>
        <!-- <div class="box22">
                  <div class="banxin">
                    <div class="txtts">

                   
                       <h2>关于我们</h2>  
                       <p>视频K歌，交友聊天，才艺表演，高颜值的都在暖暖星球</p>
                       <p class="title">【超强美颜、滤镜效果】</p>
                     <p>超多美颜滤镜、激萌自拍表情，让你自信更自我！</p>
                        <p class="title">【同城交友、时刻欢乐】</p>
                     <p>你可以通过直播、视频、文字、语音、图片来展示自己， 基于地理位置发现附近的人！</p>
                        <p class="title">【让生活更精彩、让社交更亲近】</p>
                          <p>型男美女聚集地，建立真实、有效、健康的社交关系，总有一款合适你！</p>
                          <p>4年老平台值得信赖，快进入直播间与Ta面对面互动吧，你的Ta从未如此真实，如此靠近你。</p>
                      </div>
                    </div>
                </div> -->

      </div>
      <div class="section">

        <div class="box33">
          <div class="banxin">
            <h2>联系我们</h2>
            <ul class="txtss">
              <li>
                <p class="title">联系方式</p>
                <p class="txt">联系地址：广州市天河区天河科技园</p>
                <p class="txt">联系电话：020-89810547<br>（周一至周五，10:00-18:00）</p>
                <!-- <p class="txt">客服QQ：800181050 </p> -->
                <p></p>
              </li>
              <li>
                <p class="title">微信公众号</p>
                <p class="txt">微信公众号：nnzb689</p>
                <p></p>
              </li>
              <li>
                <p class="title">联系邮箱</p>
                <p class="txt">合作&意见：kefu@gzxinyuzhou.com</p>
              </li>
              <li>
                <p class="title">商务合作</p>
                <p class="txt">公会进驻：nnzb_jiazu</p>
                <p class="txt">家族进驻：nnzb_gonghui</p>
                <p class="txt">主播进驻：nnzb_cat</p>
              </li>
            </ul>
            <p class="title">客服帮助</p>
            <p class="txt">
              为及时解决您的问题，建议您通过客户端提交意见反馈，我们会尽快在24小时内受理您的问题<br><br>
              1.客服帮助：解封相关事宜或软件使用问题请关注微信公众号“nnzb689”联系在线客服咨询<br>
              2.大额充值：请联系微信：nnzb_tu <br>
            </p>

          </div>
    <Footer></Footer>

        </div>

      </div>



    </full-page>

  </div>
</template>
<script>
import Footer from "../../components/footer"
import Header from "../../components/header"
export default {
  components: {
    Footer, Header
  },
  data() {
    return {
      name: '',
      qrcode: false,
      options: {
        licenseKey: '',
        afterLoad: this.afterLoad,
        scrollOverflow: true,
        scrollBar: false,
        setAutoScrolling: true,
        menu: '#menu',
        // navigation: true,
        // anchors: ['page1', 'page2', 'page3'],
        sectionsColor: []
      },
      listimg: []
    }
  },
  created() {
    // this.play();
    console.log(window.screen.width)

    this.listAnchor()

  },
  methods: {
    iosDown(){
       console.log('aa')
      this.$message('暂时不能下载，敬请期待');
    },
    listAnchor() {
      var _this = this
      _this.$http.get(_this.$api.listAnchor).then(function (response) {
        console.log(response.data.data);
        _this.listimg = response.data.data


      })
    },
    outqrcodeStyle() {
      this.qrcode = false
    },
    qrcodeStyle() {
      this.qrcode = true
    },
    tabclick(num) {
      sessionStorage.setItem("toptab", num);
      setTimeout(() => {
        if (num == 1) {
          this.$router.push({ path: '/pchome' })
        }
        else if (num == 2) {
          this.$router.push({ path: '/recharge' })
        }
        else if (num == 3) {
          this.$router.push({ path: '/joinus' })
        }
        else if (num == 4) {
          this.$router.push({ path: '/aboutus' })
        }
        else if (num == 5) {
          this.$router.push({ path: '/contactus' })
        }
        else if (num == 6) {
          this.$router.push({ path: '/pcenlist' })
        }
        else if (num == 7) {
          this.$router.push({ path: '/nnlive' })
        }
      }, 100)




    },
    afterLoad(anchorLink, index) {

      if (index.anchor == "page1") {
        console.log("page1")
      }
    },

  },
  mounted() {

    // new Swiper('.swiper-container',{})
  },
  beforeUpdate() {
    console.log('sjsj')
  },
  updated() {
    console.log('dhidhi')
  }
}
</script>

<style scoped lang="less">
.pchomebox {
  background: #fff;

  .box1 {
    background: url('https://resource.imbeiyu.com/gw/assets/images2/web/bg-web.png');
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    position: relative;

    .hand_phone {
      position: absolute;
      right: 0.1rem;
      bottom: 0;
      background: url('https://resource.imbeiyu.com/nnxqGw/img/pic-hand2.png');
      background-size: 100% 100%;
      width: 3.7rem;
      height: 4.06rem;
      animation: imgphone 1s;
      opacity: 1;
    }

    @keyframes imgphone {

      0%,
      to {
        opacity: 0;
        right: -1rem
      }

      100% {
        opacity: 1;
        right: 0.1rem;
      }
    }

    .topbox {
      display: flex;
      justify-content: space-between;
      height: .51rem;
      align-items: center;

      h1 {
        text-indent: -999px
      }

      .logo {
        background: url('https://resource.imbeiyu.com/gw/assets/images2/web/pic-logo.png');
        background-size: 100% 100%;
        width: 1.15rem;
        height: .25rem;
        display: block;
      }

      .tablist {
        width: 3.6rem;
        display: flex;
        margin-right: 0.1rem;
        justify-content: space-between;

        li {
          height: .08rem;
          line-height: .08rem;
          width: 25%;
          text-align: center;
          border-right: 1Px solid rgba(255, 255, 255, 0.5);
        }

        li:last-child {
          border-right: none;
        }

        li:hover {
          position: relative;

          a::after {

            content: '';
            position: absolute;
            width: 10%;
            height: .01rem;
            bottom: -.04rem;
            left: 50%;
            transform: translateX(-50%);
            background: rgba(255, 255, 255, 1);
          }
        }

        li a {
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
          font-family: PingFangSC-Medium, PingFang SC;
          font-size: .08rem;
        }

        .active {
          position: relative;

          a::after {

            content: '';
            position: absolute;
            width: 10%;
            height: .01rem;
            bottom: -.04rem;
            left: 50%;
            transform: translateX(-50%);
            background: rgba(255, 255, 255, 1);
          }
        }
      }
    }

    .txtimg {
      height: 1.756rem;
      width: 4.13rem;
      margin-top: .5rem;
      animation: txtimg 1s;
      opacity: 1;
    }

    @keyframes txtimg {

      0%,
      to {
        opacity: 0;
        margin-top: 1rem;
      }

      100% {
        opacity: 1;
        margin-top: .5rem;
      }
    }

    @keyframes imglods {

      0%,
      to {
        opacity: 0;
        margin-top: .9rem;
      }

      100% {
        opacity: 1;
        margin-top: .4rem;
      }
    }

    .lods {
      // width: 3.7rem;
      // width: 2.38rem;
      width: 4.13rem;
      height: 0.318rem;
      margin-top: .4rem;
      list-style: none;
      display: flex;
      justify-content: center;
      animation: imglods 1.3s;
      opacity: 1;

      li {
        width: 1.06rem;
        line-height: 0.318rem;
        border-radius: .085rem;

        a,
        span {
          display: block;
          width: 100%;
          height: 100%;
          text-indent: -9999px;
          opacity: .8;
        }

        a:hover,
        span:hover {
          opacity: 1;
        }
      }

      li:nth-of-type(1) {
        margin-right: 0.38rem;
      }

      li:nth-of-type(1) a {
        background: url("https://resource.imbeiyu.com/gw/assets/images/web/btn_iOS.png") center no-repeat;
        background-size: 100%;

      }

      li:nth-of-type(2) a {
        background: url("https://resource.imbeiyu.com/gw/assets/images/web/btn_android.png") center no-repeat;
        background-size: 100%;
      }

      li:nth-of-type(3) span {
        background: url("https://resource.imbeiyu.com/gw/assets/images/web/btn_code.png") center no-repeat;
        background-size: 100%;
      }

      .pr {
        position: relative;
      }

      #qrcode {
        position: absolute;
        bottom: -1.1rem;
        left: 50%;
        transform: translateX(-50%);
        width: 1.04rem;
        height: 1.04rem;
        background: url('https://resource.imbeiyu.com/gw/assets/images2/web/pic-code.png') no-repeat #fff;
        background-size: 100%;
        border-radius: 10px;
        background-clip: padding-box;
        box-shadow: 0 0 .05rem #ccc;
        z-index: 1;
      }

    }

    .jimu-page1-down {
      position: absolute;
      bottom: .3rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      -webkit-animation: jump 2s infinite;
      animation: jump 2s infinite;



      .jimu-page1-down-icon {
        background-image: url(https://img.ikstatic.cn/MTU4OTc4MDIyNjUwNCMyNjIjcG5n.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: .2rem;
        height: .2rem;
        cursor: pointer;
      }

      .jimu-page1-down-text {
        cursor: pointer;
        color: #fff;
        font-size: .08rem;
        margin-top: .08rem;
      }
    }

    @keyframes jump {

      0%,
      to {
        transform: translateY(0)
      }

      50% {
        transform: translateY(20%)
      }
    }

  }

  .box2 {
    padding-top: .01rem;
    box-sizing: border-box;
    position: relative;

    h2 {
      font-weight: 400;
      width: 100%;
      text-align: center;
      font-size: .25rem;
      color: rgba(51, 51, 51, 1);

    }

    .txt {
      margin-top: .125rem;
      letter-spacing: .14rem;
      color: #999999;
      font-size: .1rem;
      width: 100%;
      text-align: center;

    }

    .box2bgim {
      //  background:  url('https://resource.imbeiyu.com/gw/assets/PC/pic-2.png');
      //  background-size: 100% 100%;
      display: block;
      width: 100vw;
      height: 100vh;
      margin: 0 auto;

    }
  }

  .box4 {
    position: relative;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .aboutNuan {
      width: 100vw;
      height: auto;
    }
  }

  .box22 {
    padding-top: .71rem;
    box-sizing: border-box;

    .txtts {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;

      h2 {
        font-weight: 600;
        font-size: .17rem;
        color: rgba(51, 51, 51, 1);
        margin-bottom: .3rem;
      }

      p {
        font-size: .12rem;
        color: rgba(51, 51, 51, 1);
        margin-top: .12rem;
      }

      .title {
        margin-top: .3rem;
      }
    }
  }

  .box33 {
    padding-top: .01rem;
    box-sizing: border-box;

    .banxin {
      border-radius: .1rem;
      background: rgba(255, 255, 255, 1);
      padding: 0 .28rem;
      margin-top: .3rem;
      height: 3.5rem;

      h2 {
        font-weight: 600;
        width: 100%;
        text-align: center;
        font-size: .17rem;
        color: rgba(51, 51, 51, 1);

      }

      .txtss {
        display: flex;
        height: 1.87rem;
        padding-top: .56rem;
        box-sizing: border-box;
        border-bottom: 1px solid #E6E6E6;
        margin-bottom: .3rem;

        li {
          width: 23%;

        }
      }

      .title {
        font-size: 0.12rem;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        margin-bottom: .22rem;
      }

      .txt {
        font-size: 0.08rem;
        line-height: .12rem;
        color: rgba(51, 51, 51, 1);
        margin-bottom: .12rem;
      }
    }
  }

  .jimu-page1-down {
    position: absolute;
    bottom: .3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    -webkit-animation: jump 2s infinite;
    animation: jump 2s infinite;

    img {
      width: .3rem;
      height: auto;
      cursor: pointer;
    }

  }

  @keyframes jump {

    0%,
    to {
      transform: translateY(0)
    }

    50% {
      transform: translateY(20%)
    }
  }

  .box3 {
    background: rgba(250, 250, 250, 1);
    width: 100%;
    height: 100%;
    padding-top: .61rem;
    box-sizing: border-box;
    overflow: auto;
    position: relative;

    h2 {
      font-weight: 400;
      width: 100%;
      text-align: center;
      font-size: .25rem;
      color: rgba(51, 51, 51, 1);
    }

    .txt {
      margin-top: .125rem;
      letter-spacing: .14rem;
      color: #999999;
      font-size: .1rem;
      width: 100%;
      text-align: center;

    }

    .listimg {
      margin: .42rem auto 0 auto;
      width: 100%;
      align-items: center;
      display: flex;
      flex-wrap: wrap;

      li {
        padding: 2px;
        position: relative;
        margin: .005rem;

        //    height: 2.3rem;
        img {
          width: 100%;
          height: 100%;
        }

        .user_info {
          opacity: 0;
          display: flex;
          flex-direction: column;
          color: #fff;
          left: 0;
          position: absolute;
          z-index: 3;
          width: 100%;
          height: .6rem;

          background: linear-gradient(90deg, #4592FE 0%, #50DDFE 100%);
          padding: .08rem .1rem;
          box-sizing: border-box;

          p:nth-child(1) {
            width: 100%;

            span:nth-child(1) {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              display: inline-block;
              text-align: left;
              width: 50%;
              font-size: 0.12rem;
              height: .12rem;
              line-height: .12rem;
            }

            span:nth-child(2) {
              display: inline-block;
              text-align: right;
              width: 40%;
              font-size: 0.08rem;
              height: .12rem;
              line-height: .12rem;
            }
          }

          p:nth-child(2) {
            font-size: 0.06rem;
            height: .08rem;
            margin-top: .01rem;
          }

          p:nth-child(3) {
            font-size: 0.08rem;
            margin-top: .05rem;
          }
        }

      }

      li:hover {

        img {
          position: absolute;
          z-index: 4;
          animation: imgscale 1s;
          transform: scale(1.2);
          box-shadow: 0 0 10Px 5Px #fff;
        }

        .user_info {
          position: absolute;
          z-index: 5;
          bottom: -.06rem;
          animation: linge 1s;
          opacity: 1;
          transform: scale(1.2);
        }

        @keyframes imgscale {

          0%,
          to {
            transform: scale(1)
          }

          100% {
            transform: scale(1.2)
          }
        }

        @keyframes linge {

          0%,
          to {
            opacity: 0;
            transform: scale(1);
          }

          100% {
            opacity: 1;
            transform: scale(1.2)
          }
        }


      }
    }

    .li1 {
      width: 2rem;
      height: 1.1rem;

      img {
        object-fit: cover;
      }
    }

    .li2 {
      width: 1.1rem;
      height: 1.1rem;
      justify-content: space-between;
      display: flex;
      flex-direction: column;
    }

  }

  .footerbox {
    width: 100%;
    // height: 1.3rem;
    background: #Fff;
    // margin-top: .6rem;
    padding-top: .25rem;
    box-sizing: border-box;

    p {
      text-align: center;
      width: 100%;
      font-size: .075rem;
      color: rgba(102, 102, 102, 1);
      line-height: .17rem;
    }

    a {
      color: rgba(102, 102, 102, 1);
    }

    a:hover {
      color: #40a9ff;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/page/webpage/pchome.vue